var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userDetails.photourl)?_c('img',{attrs:{"src":_vm.userDetails.photourl,"alt":_vm.userDetails.fname}}):_c('span',{staticClass:"white--text text-uppercase"},[_vm._v(_vm._s(_vm.userDetails.fname[0])+_vm._s(_vm.userDetails.lname[0]))])}
var staticRenderFns = []

export { render, staticRenderFns }